const logoutEnhancer = (createStore) => (reducer, initialState, enhancer) => {
  const logout = (state, action) => {
    let _state = state;
    if (action.type === 'LOGOUT_REQUEST') {
      _state = undefined;
    }
    const newState = reducer(_state, action);
    return newState;
  };

  return createStore(logout, initialState, enhancer);
};

export default logoutEnhancer;
